/** Имя записи раскрытого листинга в history (`utils/modalHistory`): её «назад» закрывает листинг */
export const LISTING_MODAL_HISTORY_ENTRY = 'ListingModal';
